import { useUnit, useStoreMap } from 'effector-react';
import { User, USER_ROLES } from 'shared/api';
import { viewerModel } from '../model';

export const useForbiddenUserAction = (user: User) => {
	const canWriteUsers = useUnit(viewerModel.$canWriteUsers);

	const isForbidden = useStoreMap({
		store: viewerModel.$profile,
		keys: [user.id],
		fn: (profile) =>
			profile?.id === user.id ||
			(profile?.role !== USER_ROLES.god &&
				profile?.id !== user.id &&
				user.role === USER_ROLES.god) ||
			(profile?.role === USER_ROLES.admin && user.role === USER_ROLES.admin),
	});

	return !canWriteUsers || isForbidden;
};
